import {schema} from 'normalizr'

const post = new schema.Entity('posts')

export default post
